import type { AxiosInstance } from 'axios'
import { Cached } from '@coris-ts/helpers/utilities'
import { DownloadReportsInteractor } from './domain/interactors/download-reports.interactor'

export interface ReportsComponent {
  provideDownloadReports: () => DownloadReportsInteractor
}

export class ReportsDefaultModule implements ReportsComponent {
  constructor(
    private readonly baseUrl: string,
    private readonly axios: AxiosInstance
  ) {}

  @Cached()
  public provideDownloadReports(): DownloadReportsInteractor {
    return new DownloadReportsInteractor(this.baseUrl, this.axios)
  }
}
